import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useGlobalContext } from '../../contexts/GlobalContext';

//Servicios
import { AuthService } from '../../services/api';

//Componentes
import Spinner from '../../components/spinner/Spinner';
import ChangeOwnPassword from './ChangeOwnPassword';
import Modal from '../../components/modal/Modal';

function ChangeOwnPasswordContainer() {
    const { user } = useGlobalContext();
    const [loader, setLoader] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const passwordChanged = <h3>Su clave ha sido cambiada exitosamente</h3>;

    const {
        register,
        control,
        watch,
        reset,
        handleSubmit,
        setError,
        formState,
    } = useForm();

    const onSubmit = async (data) => {
        try {
            setLoader(true);

            delete data.confirm_nueva_clave;

            const changePassword = await AuthService.changeOwnPassword({
                token: user.token,
                ...data,
            });

            if (changePassword) {
                console.log(changePassword.data);
                setOpenModal(true);
            }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            return err;
        }
    };

    return loader ? (
        <Spinner />
    ) : (
        <>
            <ChangeOwnPassword
                functions={{
                    register,
                    control,
                    watch,
                    reset,
                    handleSubmit,
                    setError,
                    formState,
                    onSubmit,
                }}
            />
            <Modal isOpen={openModal} onClose={() => setOpenModal(false)}>
                {passwordChanged}
            </Modal>
        </>
    );
}

export default ChangeOwnPasswordContainer;
